import {
  BUSINESS_VERTICAL_ENERGY,
  BUSINESS_VERTICAL_TELECOM,
  BUSINESS_VERTICAL_INSURANCE,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'
import { insuranceFormParametersGeneration } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Insurance/insuranceFormParametersGeneration'
import { energyFormParametersGeneration } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Energy/energyFormParametersGeneration'
import { telecomFormParametersGeneration } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Telecom/telecomFormParametersGeneration'
import * as Sentry from '@sentry/react'

export function generateParameters({
  type,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  clientPreferences,
  action,
  contractAddressData,
  electricityMeterData,
  gasMeterData,
  propaneData,
  billingData,
  energyConsumptionData,
}) {
  if (type === BUSINESS_VERTICAL_INSURANCE) {
    return insuranceFormParametersGeneration({
      type,
      contractId,
      contactId,
      addressId,
      contractData,
      characteristicsData,
      clientPreferences,
      action,
    })
  }

  if (type === BUSINESS_VERTICAL_ENERGY) {
    return energyFormParametersGeneration({
      type,
      contractId,
      contactId,
      addressId,
      contractData,
      characteristicsData,
      mainAddressData: contractAddressData,
      clientPreferences,
      electricityMeterData,
      billingData,
      gasMeterData,
      energyConsumptionData,
      action,
      propaneData,
    })
  }

  if (type === BUSINESS_VERTICAL_TELECOM) {
    return telecomFormParametersGeneration({
      type,
      contractId,
      contactId,
      addressId,
      contractData,
      characteristicsData,
      clientPreferences,
      action,
    })
  }

  if (import.meta.env.PROD) {
    Sentry.captureException(new Error(`generateParameters: Unknown business vertical type '${type}'`), {
      extra: { type },
    })
  }
  throw new Error(`generateParameters: Unknown business vertical type '${type}'`)
}
